import ThumbnailsSdk from '@wix/thunderbolt-elements/src/components/Thumbnails/corvid/Thumbnails.corvid';


const Thumbnails = {
  sdk: ThumbnailsSdk
};


export const components = {
  ['Thumbnails']: Thumbnails
};

